import { Tutorial } from './Tutorial';
import { useFirstVisitOnboarding } from './useFirstVisitOnboarding';

export function OnboardingRoot() {
  useFirstVisitOnboarding();
  return <Tutorial />;
}
